import { useEffect, useState } from "react";
import {
    FiTarget,

    FiSave,
    FiX,
    FiXCircle,
} from "react-icons/fi";

const initialState = {
    nombre: "",
    descripcion: "",
    montoObjetivo: "",
    montoActual: "0",
    fechaObjetivo: "",
    prioridad: "1",
    estado: "ACTIVA",
};

export default function MetaForm({ initialData, onClose, onSave }) {
    const [form, setForm] = useState(initialState);

    useEffect(() => {
        if (initialData) {
            setForm({ ...initialState, ...initialData });
        } else {
            setForm(initialState);
        }
    }, [initialData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        await onSave({
            ...form,
            montoObjetivo: Number(form.montoObjetivo || 0),
            montoActual: Number(form.montoActual || 0),
            prioridad: Number(form.prioridad || 1),
        });
    };

    return (
        <div className="modal-backdrop">
            <div className="modal-card">
                <div className="modal-header">
                    <h3 style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <FiTarget size={20} />
                        {initialData ? "Editar meta" : "Nueva meta"}
                    </h3>

                    <button className="btn-secondary" type="button" onClick={onClose}>
                        <FiX size={16} />
                    </button>
                </div>

                <form className="grid-form" onSubmit={handleSubmit}>
                    <div>
                        <label>Nombre</label>
                        <input
                            name="nombre"
                            placeholder="Ej. Fondo de emergencia"
                            value={form.nombre}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label>Descripción</label>
                        <textarea
                            name="descripcion"
                            placeholder="Describe el objetivo de esta meta"
                            value={form.descripcion}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label>Monto objetivo</label>
                        <input
                            name="montoObjetivo"
                            type="number"
                            step="0.01"
                            placeholder="0.00"
                            value={form.montoObjetivo}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label>Monto actual</label>
                        <input
                            name="montoActual"
                            type="number"
                            step="0.01"
                            placeholder="0.00"
                            value={form.montoActual}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label>Fecha objetivo</label>
                        <input
                            name="fechaObjetivo"
                            type="date"
                            value={form.fechaObjetivo || ""}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label>Prioridad</label>
                        <select
                            name="prioridad"
                            value={form.prioridad}
                            onChange={handleChange}
                        >
                            <option value="1">Baja</option>
                            <option value="2">Media</option>
                            <option value="3">Alta</option>
                        </select>
                    </div>

                    <div className="form-actions full-width">
                        <button className="btn-secondary" type="button" onClick={onClose}>
                            <FiXCircle size={16} />
                            Cancelar
                        </button>

                        <button className="btn-primary" type="submit">
                            <FiSave size={16} />
                            Guardar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}